import { IActionDropdownItem } from "shared/components";

export enum IMenuItemType {
  action,
  add,
  draggable,
  default,
}

export interface IMenuItem {
  id: string;
  title: string;
  path?: string;
  matchPaths?: string[];
  onClick?: () => void;
  actions?: IActionDropdownItem[];
  icon?: React.ComponentType<any> | null;
  actionIcon?: React.ComponentType<any>;
  type?: IMenuItemType;
}

export interface ISideMenuItem extends IMenuItem {
  expandableSubItems?: boolean;
  subItems?: IMenuItem[];
}
